import { inventoryManagementHubRoute } from "@intrasync/inventory-management";
import { RouteType } from "types/RouteType";

/**
 * Inventory routes — @intrasync/inventory-management
 *
 * The module's canonical registration is the single collapsed InventoryHub
 * route (named "Inventory", path /inventory); its 16 features render as tabs
 * inside the hub, not as separate nav entries.
 *
 * The header is swapped for a host wrapper (InventoryHubHostHeader) that
 * constrains the module header inside the toolbar flex row so the tab strip
 * scrolls instead of overflowing off-screen.
 */
const hubRoute = inventoryManagementHubRoute as unknown as RouteType & {
  viewportCard: { header: Record<string, unknown> };
};

const inventoryRoutesList = [
  {
    ...hubRoute,
    viewportCard: {
      ...hubRoute.viewportCard,
      header: {
        ...hubRoute.viewportCard.header,
        // MUST be a loader, not a component: ViewportCardProvider treats any
        // plain function as a React.lazy loader.
        component: () => import("./InventoryHubHostHeader"),
      },
    },
  },
] as unknown as RouteType[];

export default inventoryRoutesList;
